module.exports = __webpack_public_path__ + "static/media/23patrimonio.54920db.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/assets/videos/23patrimonio.mp4
// module id = 726
// module chunks = 1